<style>
    .cplp_login-section .container{
        background: white;
            padding: 50px 20px;
            max-width: 700px;
    }
    .cplp_login-section input[type="text"]{
        background: #f5faff;
        max-width: 400px;
        width: 100%;
        height: 40px;
        margin: 0 auto;
     border: 2px solid #4C9AFF;
}
.cplp_login-section input[type="text"]:focus{
    border: 2px solid #000;
    outline: none;
    box-shadow: none;
}
    .cplp_login-section input[type="submit"]{
        max-width: 400px;
        width: 100%;
        height: 40px;
        font-family: Open Sans;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        background: #253858;
        border-radius: 3px;
        margin-top: 0;
        box-shadow: none;
    }
    .cplp_login-submit{
        margin-top: 0;
    }
    img.logo {
        width: auto;
        margin: 0 auto 30px;
    }
    @media only screen and (max-width: 767px)
    {
    .cplp_login-section {
        
        padding: 0px !important;
      
    }
    .cplp_login-body {
        background-color: #fff !important;
    }
    }
    .cplp_login-section input[type="submit"]:hover{
        background: #253858c9;
		text-decoration: inherit;
		transition-duration: 0s, 0.15s;
		color: var(--ds-text-inverse, #FFFFFF) !important;
}

    </style>
<div style="background-color: rgb(245, 250, 255);" [ngStyle]="{'height': isPopup ? '100%' : '100vh'}" class="cplp_login-body" [@routerTransition]>
    <div class="wrapper" [ngStyle]="{'height': isPopup ? '100%' : 'auto'}">
        <div id="cplp_login_main" class="cplp_login_main" [ngStyle]="{'height': isPopup ? '100%' : 'auto'}">
            <div class="cplp_login-section" [ngStyle]="{'height': isPopup ? '100%' : 'auto'}">
                <div class="container" [ngStyle]="{'height': isPopup ? '100%' : 'auto'}">
                    <div class="row align-center">
                        <div class="col-md-12 col-lg-12">
                            <div class="cplp_login-intro">
                                <!-- <h1>Cable Pro<sup class="cplp_sup">TM</sup></h1>
                                <h2>Web Edition</h2> -->
                                <img *ngIf="!isPopup" src="/assets/anonymouspage/images/logo.png" alt="" class="logo" style="padding-left : 0px"/>
                                <h2> {{l('VerifySecurityCode')}}</h2>
                            </div>
                            <div class="contact-form wow fadeInDown">
                                <form #twoFactorForm="ngForm" class="m-login__form m-form verify-security-code-form" method="post" (ngSubmit)="submit()">
                                    <div class="controls">
                                        <div class="row">
                                          
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <div class="form-group m-form__group">
                                                        <input #passwordInput="ngModel" autoFocus [(ngModel)]="code" class="form-control form-control-solid placeholder-no-fix input-ltr" type="text" autocomplete="off" placeholder="{{l('Code')}} *" name="code" required maxlength="16" />
                                                        <validation-messages [formCtrl]="passwordInput"></validation-messages>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                        </div>
                                        <div class="row cplp_login-submit">
                                            <div class="col-md-12" style="margin: auto; max-width: 400px; padding: 0px;">
                                                <input type="submit"  class="buttonclass"  [disabled]="!twoFactorForm.form.valid" [buttonBusy]="submitting" [busyText]="l('SavingWithThreeDot')" value="SUBMIT">
                                                <span class="remaining-time-counter" [ngClass]="{'remaining-time-counter-center': isPopup}">{{l("RemainingTime")}}: {{l("SecondShort{0}", remainingSeconds)}}.</span>                                
                                            </div>
                                           
                                        </div>

                                        <div class="row cplp_login-register">
                                            <div class="col-md-3"></div>
                                            <div class="col-md-6 cplp_login-create mb-3">
                                                <a (click)="returnToLogin()">Return to log in</a>
                                            </div>
                                            <div class="col-md-3"></div>
                                        </div>
                                        <hr *ngIf="!isPopup">
                                        <div *ngIf="!isPopup" class="row cplp_login-footer">
                                            <div class="col-md-3"></div>
                                            <div class="col-md-6 mt-3">
                                                <img class="cplp_login-logo" src="/assets/anonymouspage/images/Elek-Footer.png" alt="Electrotechnik Pty Ltd">
                                                <p>For more information, visit <a href="https://elek.com" target="_blank">elek.com</a></p>
                                            </div>
                                            <div class="col-md-3"></div>
                                        </div>
                                    </div>

                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>